import { jsx } from '@emotion/react/jsx-runtime';
import { useMemo } from 'react';
import { css } from '@emotion/react';
import { glyph, glyphSm, glyphMd, glyphLg } from '../../styles/glyph.js';

const sizes = {
  sm: glyphSm,
  md: glyphMd,
  lg: glyphLg
};
const Glyph = ({
  children,
  size = "sm",
  theme = {},
  ...otherProps
}) => {
  const styles = useMemo(() => css(glyph, sizes[size], theme), [size, theme]);
  return /* @__PURE__ */ jsx("span", { css: styles, ...otherProps, children });
};

export { Glyph as default };
